export default [{
    title: "Sistemas",
    fontIcon: "laptop-code",
    resource: "Sistemas",
    action: "ver-sistemas",
    children: [
        {
            title: "Dashboard",
            icon: "LayoutIcon",
            resource: "Exportaciones",
            action: "ver-sistemas-dashboard",
            children: [{
                route: "sistemas-dashboard-monitor-bot",
                title: "Monitor Bot",
                resource: "Sistemas",
                action: "ver-sistemas-dashboard-monitor-bot",
            }]
        },{
        title: "Mantenimiento",
        icon: "EditIcon",
        resource: "Sistemas",
        action: "ver-sistemas-mantenimiento",
        children: [{
            route: "sistemas-usuarios",
            title: "Usuarios",
            resource: "Sistemas",
            action: "ver-sistemas-mantenimiento-usuarios",
        }, {
            route: "sistemas-usuarios-roles-crear",
            title: "Roles",
            resource: "Sistemas",
            action: "ver-sistemas-mantenimiento-roles",
        }, {
            route: "sistemas-empresas",
            title: "Empresas",
            resource: "Sistemas",
            action: "ver-sistemas-mantenimiento-empresas",
        }, {
            route: "sistemas-mantenimiento-firma-electronica",
            title: "Firma Electrónica",
            resource: "Sistemas",
            action: "ver-sistemas-mantenimiento-firma-electronica",
        }, 
    ]
    }]
}]